import React from "react";
import { Rocket, Zap, Users } from "lucide-react";
import AudienceLanding from "../components/AudienceLanding";

export default function Entrepreneurs() {
  return (
    <AudienceLanding
      audienceSlug="entrepreneur"
      landingParam="entrepreneurs"
      registerAudienceParam="entrepreneur"
      testidPrefix="entrepreneurs-landing"
      hero={{
        overline: "PREMIUM AI ACADEMY FOR FOUNDERS",
        headline: (
          <>
            Build AI into<br/>
            your business —<br/>
            <span className="text-fc-red">without a CTO.</span>
          </>
        ),
        subhead: "Founder-focused AI playbooks: from first prompt to deployed product. Build in days, not quarters.",
        heroImage: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=2000&q=80",
      }}
      stats={[
        { icon: Rocket, value: "1,200+", label: "Founders Trained" },
        { icon: Zap, value: "9", label: "Deployable Workflows" },
        { icon: Users, value: "60+", label: "Operator Instructors" },
      ]}
      testimonials={[
        { name: "Naomi Park", role: "Founder, Stitch Labs", quote: "Freddy turned a 3-month CTO hire into a 2-week launch. We deployed our AI support agent on a Wednesday." },
        { name: "Diego Romero", role: "Founder, Veloci Studio", quote: "AI 101 for Business Owners is the only AI course I make my team finish before they touch a customer." },
        { name: "Jin Park", role: "Co-Founder, FrameRate", quote: "Generated 12 landing-page variants in a Friday afternoon. CTR up 30%, no developer needed." },
      ]}
      featuredHeadline={
        <>Where founders <span className="text-fc-red">build.</span></>
      }
    />
  );
}
